module.exports = __webpack_public_path__ + "img/whats-new-desktop_jp.9c76b55.jpg";